import { Divider } from '@mui/material';
import React, { useState } from 'react';
import Modal from 'react-modal';

// This is needed for accessibility reasons, and should be set to the root app element
Modal.setAppElement('#root');

const TermsAndConditions = ({ handleAcceptTC }) => {
  const [modalIsOpen, setIsOpen] = useState(false);
  const [isChecked, setChecked] = useState(false);

  const openModal = () => {
    setIsOpen(true);
  };

  const closeModal = () => {
    setIsOpen(false);
  };

  const handleAccept = () => {
		handleAcceptTC();
    closeModal();
  };

  const handleCheckboxChange = () => {
    setChecked(!isChecked);
  };

  return (
    <div>
    	<input style={{ marginRight: 5 }} type="checkbox" id="accept" onChange={handleAccept} />
			Accept our
      <button style={{
				marginLeft: 5,
				marginRight: 5,
				color: '#2196f3'
			}} onClick={openModal}>Terms and Conditions</button>
			to proceed with the payment.
      <Modal
        isOpen={modalIsOpen}
        onRequestClose={closeModal}
        contentLabel="Terms and Conditions"
      >
        <h2>Terms and Conditions</h2>
				<Divider sx={{ marginTop: 4 }}/>
        <div>
          <p>
            {/* Replace with your actual terms and conditions content */}
            Lorem ipsum dolor sit amet, consectetur adipiscing elit. Fusce
            hendrerit vel elit at maximus. Pellentesque habitant morbi tristique
            senectus et netus et malesuada fames ac turpis egestas. Mauris
            tempus, odio sit amet maximus pellentesque, enim libero varius
            justo, vel mollis ligula erat non mi.
          </p>
        </div>
        <div>
          <button onClick={closeModal}
						style={{
							marginLeft: 5,
							marginTop: 20,
							marginRight: 5,
							color: '#d32f2f'
						}}
					>Close</button>
        </div>
      </Modal>
    </div>
  );
};

export default TermsAndConditions;
